/**
 * App-wide brand theme (also used by conference / reservations pages).
 * Logo: Bedrock Slate wordmark from brand/_LogoKit (copied to public/brand/).
 * Colors: Graystone, Limestone, Beacon Yellow, Bedrock Slate per ColorSheet.
 * Font: Normalidad VF from brand/BrandFont (copied to public/brand/fonts/).
 * Global CSS (font-face, CSS variables, navbar, footer): src/brand/brand.css
 */
const publicUrl = process.env.PUBLIC_URL || '';

/** Header logo – Bedrock Slate wordmark (works on limestone/white header) */
export const brandLogo = `${publicUrl}/brand/wordmark-bedrock-slate.svg`;

/** White wordmark – for the dark (Bedrock Slate) navbar */
export const brandLogoWhite = `${publicUrl}/brand/wordmark-white.svg`;

/** Circle badge – centered footer mark at the bottom of every page */
export const brandBadge = `${publicUrl}/brand/bedrock-circle-badge-bedrock-slate-rgb.svg`;

/** Path for Normalidad VF font (used in reserve pages) */
export const brandFontUrl = `${publicUrl}/brand/fonts/Normalidad%20VF.otf`;

export const brandColors = {
  /** Graystone – body text, labels, secondary UI */
  graystone: '#86878B',
  /** Limestone – page/card backgrounds */
  limestone: '#F2F0EB',
  /** Beacon Yellow – accent, CTAs, highlights */
  beaconYellow: '#E6FF2F',
  /** Bedrock Slate – headers, primary buttons, dark UI */
  bedrockSlate: '#262626',
  /** Primary = Bedrock Slate (buttons, header bar) */
  primary: '#262626',
  primaryHover: '#1a1a1a',
  /** White / light surfaces */
  white: '#ffffff',
  /** Border and dividers (graystone tint) */
  border: '#d4d4d4',
  /** Success (checkmark, success state) */
  success: '#059669',
  /** Text on primary buttons (Beacon Yellow on Bedrock Slate) */
  onPrimary: '#E6FF2F',
  /** Status Good */
  statusGood: '#22c55e',
  /** Status Warning */
  statusWarning: '#f59e0b',
  /** Status Error */
  statusError: '#ef4444',
};

export default { brandLogo, brandColors };
